import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

import repaint from 'utils/repaint';

export default Component((node) => {
  const { target, stop } = node.dataset;

  if (!target) {
    throw new Error('Missing data-target attribute.');
  }

  const targetElement = document.querySelector<HTMLElement>(target);

  const update = ({ isIntersecting }: IntersectionObserverEntry) => {
    const isActive = !isIntersecting;

    if (isActive) {
      fastdom.measure(() => {
        node.hidden = false;
        repaint(node);
      });

      fastdom.mutate(() => {
        node.classList.add('is-active');
      });
    } else {
      fastdom.mutate(() => {
        node.classList.remove('is-active');
      });
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        update(entry);
      });
    },
    {
      rootMargin: node.dataset.offset ?? '0px',
    },
  );

  if (stop) {
    const stopElement = document.querySelector<HTMLElement>(stop);

    if (!stopElement) {
      throw new Error(`${stop} attribute, didn't match any elements on site.`);
    }

    observer.observe(stopElement);
  }

  if (target && targetElement) {
    observer.observe(targetElement);
  }
});
